import { useEffect, useRef } from 'react';

import { useTelemetry } from '@order/Telemetry';

import { usePostLoginRedirectHref } from '../../context/AuthMachine';
import { useCustomer } from '../../context/Customer';

// ─────────────────────────────────────────────────────────────────────────────

export const useTrackSignInSuccess = () => {
  const postLoginRedirectHref = usePostLoginRedirectHref();
  const { customer } = useCustomer();
  const { track } = useTelemetry();

  // ─── Refs ────────────────────────────────────────────────────────────

  const trackRef = useRef(track);

  trackRef.current = track;

  // ─── Effects ─────────────────────────────────────────────────────────

  useEffect(() => {
    if (!postLoginRedirectHref || !customer.id) return;

    trackRef.current('sign-in.success', { userId: customer.id });
  }, [postLoginRedirectHref, customer.id]);
};
